// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    bindActionCreators,
    Dispatch,
} from 'redux';
import * as vmActions from 'common/modules/computeResourceVm/actions';
import { connect } from 'react-redux';
import { LOADING_FLAGS } from 'common/modules/app/loadingFlags/constants';
import { RootState } from 'admin/core/store';
import VncDialog from 'common/containers/VncDialog/VncDialog';
import { hasPermission } from 'common/modules/permission/selectors';
import { PERMISSION_LIST } from 'common/modules/permission/constants';
import { FEATURES } from 'common/modules/app/features/constants';
import { isFeatureFlagEnabled } from 'common/modules/app/features/utils';

const mapStateToProps = (state: RootState) => ({
    isAuthenticated: state.auth.isAuth,
    vm: state.computeResourceVm.item,
    isLoadingVm: state.app.loadingFlags.has(LOADING_FLAGS.COMPUTE_RESOURCE_VM),
    isSettingVncUp: state.app.loadingFlags.has(LOADING_FLAGS.VNC_UP),
    canOpenVncConsole: hasPermission(state, PERMISSION_LIST.OPEN_VNC_CONSOLE, PERMISSION_LIST.MANAGE_SERVERS),
    directConnection: isFeatureFlagEnabled(state, FEATURES.DIRECT_VNC),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    getComputeResourceVm: bindActionCreators(vmActions.getComputeResourceVm, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(VncDialog);
